import React from 'react';
import CompleteHeader from './Header/CompleteHeader';


const Settings = () => {
  return (
    <CompleteHeader>
      <div>
        <h1>Settings</h1>
      </div>
    </CompleteHeader>
  );
};

export default Settings;